"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _nodeEmoji = _interopRequireDefault(require("node-emoji"));

var _text = _interopRequireDefault(require("@react-x/text"));

// Libraries
var Emoji = function Emoji(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? _text["default"] : _ref$component,
      name = _ref.name,
      style = _ref.style;
  return _react["default"].createElement(Component, {
    style: style
  }, _nodeEmoji["default"].get(name));
};

var _default = Emoji;
exports["default"] = _default;